import React, { useEffect, useRef } from 'react';
import { Hero } from './Hero';
import { Story } from './Story';
import { Quotes } from './Quotes';
import { BookDetails } from './BookDetails';
import { SpecialOffer } from './SpecialOffer';
export function BookPromo() {
  const offerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = (e: Event) => {
      e.preventDefault();
      if (offerRef.current) {
        offerRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };
    const links = document.querySelectorAll('a[href="#offer"]');
    links.forEach(link => {
      link.addEventListener('click', handleScroll);
    });
    return () => {
      links.forEach(link => {
        link.removeEventListener('click', handleScroll);
      });
    };
  }, []);
  return <div className="w-full" data-id="element-55">
      <Hero data-id="element-56" />
      <Story data-id="element-57" />
      <Quotes data-id="element-58" />
      <BookDetails data-id="element-59" />
      <div ref={offerRef} data-id="element-60">
        <SpecialOffer data-id="element-61" />
      </div>
    </div>;
}